import { render, staticRenderFns } from "./ScheduleIndex.vue?vue&type=template&id=bf46fda8"
import script from "./ScheduleIndex.vue?vue&type=script&lang=js"
export * from "./ScheduleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports